import { type FC, type ReactNode } from 'react';

type CollapsibleSectionProps = {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
};

export const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  title,
  isExpanded,
  onToggle,
  children,
  className = '',
}) => (
  <div className={`consolidationModal__collapsibleSection ${className}`}>
    <button
      onClick={onToggle}
      className={`consolidationModal__collapsibleHeader ${
        isExpanded
          ? 'consolidationModal__collapsibleHeader--expanded'
          : 'consolidationModal__collapsibleHeader--collapsed'
      }`}
    >
      <span>{title}</span>
      <span className="consolidationModal__collapsibleIcon">{isExpanded ? '▼' : '▶'}</span>
    </button>
    {isExpanded && <div className="consolidationModal__collapsibleContent">{children}</div>}
  </div>
);
